import './SuggestionGroupLabel.css';
export var suggestionGroupLabelCSS = '_rrroaa0-2-0-1';